<template>
  <footer class="mira-footer">
    <!-- Main Footer -->
    <div class="mira-footer__main">
      <div class="mira-footer__container">
        <div class="mira-footer__grid">
          <!-- Company Info -->
          <div class="mira-footer__col mira-footer__col--brand">
            <div class="mira-footer__brand">
              <img :src="logo" alt="Miraverse.ID" class="mira-footer__logo" />
              <span class="mira-footer__brand-name">
                Miraverse<span class="footer-accent">.ID</span>
              </span>
            </div>
            <p class="mira-footer__desc">
              Partner terpercaya Anda dalam dunia digital. Kami menghadirkan
              solusi teknologi inovatif untuk membantu bisnis Anda mencapai
              potensi terbaiknya.
            </p>
            <!-- <div class="mira-footer__social">
              <a href="https://www.instagram.com" target="_blank" class="mira-footer__social-link"
                aria-label="Instagram">
                <i class="fa fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com" target="_blank" class="mira-footer__social-link" aria-label="LinkedIn">
                <i class="fa fa-linkedin"></i>
              </a>
              <a href="https://www.facebook.com" target="_blank" class="mira-footer__social-link" aria-label="Facebook">
                <i class="fa fa-facebook-f"></i>
              </a>
              <a href="https://www.youtube.com" target="_blank" class="mira-footer__social-link" aria-label="YouTube">
                <i class="fa fa-youtube"></i>
              </a>
              <a href="https://www.twitter.com" target="_blank" class="mira-footer__social-link" aria-label="Twitter">
                <i class="fa fa-twitter"></i>
              </a>
            </div> -->
          </div>

          <!-- Quick Links -->
          <div class="mira-footer__col">
            <h4 class="mira-footer__heading">Navigasi</h4>
            <ul class="mira-footer__list">
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/about">Tentang Kami</router-link></li>
              <li><router-link to="/services">Layanan</router-link></li>
              <li><router-link to="/projects">Proyek</router-link></li>
              <li><router-link to="/contact">Kontak</router-link></li>
            </ul>
          </div>

          <!-- Services -->
          <div class="mira-footer__col">
            <h4 class="mira-footer__heading">Layanan Kami</h4>
            <ul class="mira-footer__list">
              <li><a href="#">Company Website</a></li>
              <li><a href="#">Aplikasi Web & Mobile</a></li>
              <li><a href="#">Sistem ERP</a></li>
              <li><a href="#">Sistem CRM</a></li>
              <li><a href="#">WhatsApp Business</a></li>
              <li><a href="#">Cloud & Domain</a></li>
            </ul>
          </div>

          <!-- Contact -->
          <div class="mira-footer__col">
            <h4 class="mira-footer__heading">Hubungi Kami</h4>
            <ul class="mira-footer__contact-list">
              <li>
                <i class="fa fa-map-marker"></i>
                <span>PT. Mira Bisa Berteknologi<br>Citra Maja City, Cluster Vimala M16/01, Maja Baru, Lebak
                  Banten 42382</span>
              </li>
              <li>
                <i class="fa fa-phone"></i>
                <span><a class="custom-link" href="https://wa.me/628114938580">+62 8114938580</a></span>
              </li>
              <li>
                <i class="fa fa-envelope"></i>
                <span><a class="custom-link" href="mailto:info@miraverse.id">info@miraverse.id</a></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="mira-footer__bottom">
      <div class="mira-footer__container">
        <div class="mira-footer__bottom-inner">
          <p>
            &copy; {{ currentYear }} PT. Mira Bisa Berteknologi. All rights
            reserved.
          </p>
          <div class="mira-footer__bottom-links">
            <router-link to="/privacy">Kebijakan Privasi</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
  data() {
    return {
      logo: require("@/assets/images/logo-mira.png"),
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
.mira-footer {
  background: #0f0520;
  color: rgba(255, 255, 255, 0.7);
}

.mira-footer__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.mira-footer__main {
  padding: 80px 0 40px;
}

.mira-footer__grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 48px;
}

.mira-footer__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.mira-footer__logo {
  height: 42px;
}

.mira-footer__brand-name {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;

  .footer-accent {
    color: #c73468;
  }
}

.mira-footer__desc {
  font-size: 0.9rem;
  line-height: 1.7;
  margin-bottom: 24px;
  color: rgba(255, 255, 255, 0.55);
}

.mira-footer__social {
  display: flex;
  gap: 10px;
}

.mira-footer__social-link {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: linear-gradient(135deg, #6c2973, #c73468);
    color: #fff;
    transform: translateY(-2px);
  }
}

.mira-footer__heading {
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 24px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 30px;
    height: 2px;
    background: linear-gradient(90deg, #c73468, transparent);
  }
}

.mira-footer__list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 10px;
  }

  a {
    color: rgba(255, 255, 255, 0.55);
    font-size: 0.9rem;
    text-decoration: none;
    transition: all 0.25s ease;
    display: inline-block;

    &:hover {
      color: #c73468;
      transform: translateX(4px);
    }
  }
}

.mira-footer__contact-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.55);

    i {
      color: #c73468;
      font-size: 0.9rem;
      margin-top: 4px;
      flex-shrink: 0;
    }
  }
}

.mira-footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 20px 0;
}

.mira-footer__bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.4);
    margin: 0;
  }
}

.mira-footer__bottom-links {
  a {
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.85rem;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #c73468;
    }
  }
}

.custom-link {
  color: inherit;
}

@media (max-width: 991px) {
  .mira-footer__grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
}

@media (max-width: 576px) {
  .mira-footer__grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .mira-footer__main {
    padding: 50px 0 30px;
  }

  .mira-footer__bottom-inner {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}
</style>
